import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function ReviewsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/reviews").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false)); }, []);
  return (
    <div className="cs-container py-10" data-testid="reviews-page">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900">Customer Reviews</h1>
      <p className="mt-3 text-gray-600">Real stories from Carz Swag customers.</p>
      {loading ? (
        <div className="mt-8 text-gray-500">Loading…</div>
      ) : items.length === 0 ? (
        <div className="mt-10 border border-dashed border-gray-200 rounded-xl p-12 text-center text-gray-500">
          No reviews yet. Share your experience with us.
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((r) => (
            <div key={r.id} className="rounded-xl border border-gray-200 p-5 bg-white">
              <div className="flex items-center gap-1 text-[#F59E0B]">
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={14} className={i < r.rating ? "fill-[#F59E0B]" : "text-gray-200"} />)}
              </div>
              <p className="mt-3 text-sm text-gray-700 leading-relaxed">"{r.review}"</p>
              <div className="mt-4 text-xs">
                <div className="font-bold text-gray-900">{r.customer_name}</div>
                {r.vehicle_purchased && <div className="text-gray-500">{r.vehicle_purchased}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
